module.exports = __webpack_public_path__ + "static/media/comercioExterior.bef692db.svg";